import React, { useState,useEffect,useRef,forwardRef } from 'react'
import * as permStorage from '../helpers/permanent-storage'
import * as firebase from '../helpers/firebase'
import './NoteTitleBox.scss'

// Accepts note input and saves it.
// Saves to Localstorage onChange.
// Saves permanently to DB onBlur.
// Only note.data gets written to the db, the rest of the fields are metadata.
// Even if the user is offline, notes get "written" to Firestore when the saveNote function runs.
// Once the user gets back online, Firestore will save it to the database. Even unsaved notes show up in the notes list immediately.
const NoteInputBox = forwardRef((props,ref) => {
    const existingNote = permStorage.getCurrentNote()
    const emptyNote = {
        id: undefined,
        data: {
            text: ''
        }
    }

    return (
        <div className="container position-relative" id="note-title-container">
            <div className="row">
                <div className="col-9 note-title-textarea-wrapper ml-0 d-flex">
                    <textarea
                        ref = {props.refNewTitleBox}
                        className='note-title mx-auto'
                        placeholder='Add a title...'
                        aria-multiline={true}
                        aria-label='Note input'
                    ></textarea>
                </div>
            </div>
        </div>
    )
})

export default NoteInputBox